import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { LoadingButton } from '@mui/lab';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Modal, Box, Button } from '@mui/material';
import { faBuilding, faEnvelope, faCircleInfo } from '@fortawesome/free-solid-svg-icons';
import PhoneInput from 'react-phone-input-2';
import logo from '../../assets/logos/whizzc_logo.png';
import pattern from '../../assets/authentication/signup_pattern.png';
import animated_img from '../../assets/authentication/animated_compliance_img.png';
import google_sso from '../../assets/authentication/google_icon_sso.png';
import microsoft_sso from '../../assets/authentication/microsoft_icon_sso.png';
import '../../styles/signup.css';
import 'react-phone-input-2/lib/style.css';

const RegistrationForm = () => {
  const navigate = useNavigate();
  const [orgName, setOrgName] = useState('');
  const [email, setEmail] = useState('');
  const [isValidEmail, setIsValidEmail] = useState(true);
  const [contact, setContact] = useState('');
  const [isValidContact, setIsValidContact] = useState(false); // New state for contact validation
  const [Loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [open, setOpen] = useState(false);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const validateOrgName = (input) => {
    const validOrgName = input.replace(/[^a-zA-Z\s]/g, '');
    setOrgName(validOrgName);
  };

  const handleOrgName = (e) => {
    const orgname = e.target.value;
    if (orgname.length <= 50) {
      validateOrgName(orgname);
    }
  };

  const validateEmail = (email_input) => {
    const validOrgEmail = /^(?!.*@(gmail\.com|yahoo\.com|outlook\.com|inbox\.com$))(?=.*@[^0-9]{4,}\..*$).+$/i;
    const isValid = validOrgEmail.test(email_input);
    setIsValidEmail(isValid);
    return isValid;
  };

  const handleEmailInput = (event) => {
    const emailInput = event.target.value;
    setEmail(emailInput);
    validateEmail(emailInput);
  };

  const handleContactChange = (contact_no) => {
    setContact(contact_no);
    // Validate the contact number
    const isValid = contact_no && contact_no.length >= 12;
    setIsValidContact(isValid);
  };

  const handleForm = (event) => {
    event.preventDefault();
    console.log('Email:', email);
    console.log('Contact:', contact);
    console.log('Is Valid Email:', isValidEmail);

    if (!email || !contact || !isValidEmail || !isValidContact) {
      console.log('Form cannot be submitted');
      return;
    }

    setLoading(true);
    setErrorMessage('');
    const formdata = new FormData(event.target);
    formdata.append('phone_number', contact.slice(2));

    fetch(
      process.env.REACT_APP_BACKEND + 'opensa/tenantmodule/register/',
      {
        method: 'POST',
        body: formdata,
      }
    )
      .then((response) => {
        if (!response.ok) {
          return response.json().then((data) => {
            throw new Error(data.message || 'Organization already registered, please sign in with email and password');
          });
        }
        return response.json();
      })
      .then((data) => {
        alert('A registration confirmation email has been sent to your email address.');
        navigate('/success');
      })
      .catch((error) => {
        setErrorMessage(error.message);
        console.log('There was a problem with the request: ', error);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <div className="signup_container">
      <span><img src={logo} alt="" id='logo' /></span>
      <img src={pattern} alt="" className="pattern" />
      <div className="content_container registration">
        <section className="left_side_container">
          <img src={animated_img} alt="" />
          <h1 className="left_container_phrase">
            STAY CONFIDENT AND <span id="compliant">COMPLIANT</span> WITH WHIZZC
          </h1>
        </section>
        <section className="right_side_container">
          <h2 className="welcome_to_whizzc">
            Welcome to Whizz<span id="C_of_whizzC">C</span>
          </h2>
          <section className="input_fields_container">
            <h3>Sign up with your organization email address</h3>
            <form onSubmit={handleForm}>
              <div className="input-group">
                <FontAwesomeIcon icon={faBuilding} className="input_icons" />
                <input
                  type="text"
                  placeholder="Organization Name *"
                  value={orgName}
                  onChange={handleOrgName}
                  id="org_name"
                  name="org_name"
                  required
                  style={{
                    width: '100%',
                    padding: '20px 20px 20px 65px',
                    // marginBottom: '3px',
                    fontSize: '14px',
                    border: '1px solid #ccc',
                    borderRadius: '4px',
                  }}
                />
              </div>

              <div className="input-group">
                <FontAwesomeIcon icon={faEnvelope} className="input_icons" />
                <input
                  type="email"
                  placeholder="Organization Email Address *"
                  required
                  value={email}
                  name="org_email"
                  onChange={handleEmailInput}
                  style={{
                    width: '100%',
                    padding: '20px 20px 20px 65px',
                    // marginBottom: '3px',
                    fontSize: '14px',
                    border: '1px solid #ccc',
                    borderRadius: '4px',
                  }}
                />
              </div>
              {!isValidEmail && (
                <div id="error_org_email" style={{ color: 'red', fontSize: 'small' }}>
                  <FontAwesomeIcon icon={faCircleInfo} className="info_icon" />
                  <p>Enter a valid organisation Email ID</p>
                </div>
              )}
              <div className="input-group">
                <PhoneInput
                  value={contact}
                  country="in"
                  placeholder="Contact Number *"
                  inputClass="contact_input"
                  buttonClass="country_code"
                  onChange={handleContactChange}
                  inputProps={{
                    'data-name': 'phone_number',
                    required: true,
                  }}
                  containerStyle={{
                    width: '100%',
                    // marginBottom: '3px',
                  }}
                  inputStyle={{
                    width: '100%',
                    padding: '18px',
                    fontSize: '14px',
                    border: '1px solid #ccc',
                    borderRadius: '4px',
                  }}
                  buttonStyle={{
                    height: '62px',
                    border: '1px solid #ccc',
                    borderRadius: '4px 0 0 4px',
                  }}
                />
              </div>
              {errorMessage && (
                <div id="error_message" style={{ color: 'red', fontSize: 'small', marginTop: '5px' }}>
                  <FontAwesomeIcon icon={faCircleInfo} className="info_icon" />
                  <p>{errorMessage}</p>
                </div>
              )}
              <LoadingButton 
                type='submit' 
                loading={Loading} 
                className='signup_btn' 
                disabled={!(email && contact && isValidEmail && isValidContact)} 
                sx={{ 
                  fontFamily: "Montserrat,sans-serif",
                  width: '100%',
                  padding: '10px',
                  // marginTop: '5px',
                }}
              >
                {!Loading ? 'Sign Up' : 'Signing Up....'}
              </LoadingButton>
            </form>
            <p id="agreement" style={{ marginTop: '10px' }}>
              By registering, You agree to our{' '}
              <span id="terms_and_conditions" onClick={handleOpen} style={{ cursor: 'pointer' }}>Terms and Conditions</span>
            </p>
          </section>
        </section>
      </div>

      <TermsAndConditionsModal open={open} handleClose={handleClose} />
    </div>
  );
};

const TermsAndConditionsModal = ({ open, handleClose }) => {
  
  const termsHtml = `

    <h6>1. Acceptance of Terms:</h6>
    <p style="font-size: 0.700rem;">By accessing or using the Website or Services, you agree to comply with these Terms and all applicable laws and regulations. If you do not agree with these Terms, you may not access or use the Website or Services.</p>
    <h6>2. Use of Services:</h6>
    <p style="font-size: 0.700rem;">You may use the Services provided by WhizzC solely for your own internal business purposes. You agree not to resell, distribute, or sublicense the Services to any third party.</p>
    <h6>3. Registration and Account Security:</h6>
    <p style="font-size: 0.700rem;">In order to access certain features of the Services, you may be required to register for an account with WhizzC. You agree to provide accurate and complete information when registering for an account and to update your information promptly if it changes. You are responsible for maintaining the confidentiality of your account credentials and for all activities that occur under your account.</p>
    <h6>4. Intellectual Property Rights:</h6>
    <p style="font-size: 0.700rem;">The Website and Services, including all content, features, and functionality, are owned by WhizzC and are protected by intellectual property laws. You may not modify, reproduce, distribute, or create derivative works based on the Website or Services without the prior written consent of WhizzC.</p>
    <h6>5. Privacy:</h6>
    <p style="font-size: 0.700rem;">Your privacy is important to us. Please review our Privacy Notice to understand how we collect, use, and disclose your information when you use the Website or Services.</p>
    <h6>6. Disclaimer of Warranties:</h6>
    <p style="font-size: 0.700rem;">THE WEBSITE AND SERVICES ARE PROVIDED ON AN “AS IS” AND “AS AVAILABLE” BASIS, WITHOUT ANY WARRANTIES OF ANY KIND, EITHER EXPRESS OR IMPLIED. WHIZZC DISCLAIMS ALL WARRANTIES, INCLUDING, BUT NOT LIMITED TO, IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, AND NONINFRINGEMENT.</p>
    <h6>7. Limitation of Liability:</h6>
    <p style="font-size: 0.700rem;">IN NO EVENT SHALL WHIZZC BE LIABLE FOR ANY INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL, OR PUNITIVE DAMAGES ARISING OUT OF OR IN CONNECTION WITH YOUR USE OF THE WEBSITE OR SERVICES, EVEN IF WHIZZC HAS BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGES.</p>
    <h6>8. Indemnification:</h6>
    <p style="font-size: 0.700rem;">You agree to indemnify, defend, and hold harmless WhizzC and its officers, directors, employees, and agents from and against any and all claims, liabilities, damages, losses, costs, or expenses arising out of or in connection with your use of the Website or Services or your violation of these Terms.</p>
    <h6>9. Governing Law:</h6>
    <p style="font-size: 0.700rem;">These Terms shall be governed by and construed in accordance with the laws of [insert jurisdiction], without regard to its conflict of law principles.</p>
    <h6>10. Changes to Terms:</h6>
    <p style="font-size: 0.700rem;">WhizzC reserves the right to modify or update these Terms at any time without prior notice. Any changes to these Terms will be effective immediately upon posting on the Website. Your continued use of the Website or Services after the posting of changes constitutes your acceptance of such changes.</p>
    <h6>11. Contact Us:</h6>
    <p style="font-size: 0.700rem;">If you have any questions or concerns about these Terms, please contact us at <a href="mailto:support@whizzc.com">support@whizzc.com</a>.</p>
    <p style="font-size: 0.700rem;">Thank you for using WhizzC!</p>
  `;


  return (
    <Modal open={open} onClose={handleClose}>
      <Box sx={{
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '50%',
        bgcolor: 'background.paper',
        borderRadius: 2,
        boxShadow: 24,
        p: 4,
        maxHeight: '80vh',
        overflowY: 'auto',
      }}>
        <div dangerouslySetInnerHTML={{ __html: termsHtml }} />
        <Button onClick={handleClose} sx={{ mt: 2 }}>Close</Button>
      </Box>
    </Modal>
  );
};

export default RegistrationForm;
